module.exports = __webpack_public_path__ + "img/ar.60ee8fbc.svg";